import { Spin } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import appConfig from "@/config/appConfig";
import { DataTable } from "@/components";
import { userRole } from "@/constant";

const ActivityLog = () => {
  const [admins, setAdmins] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");

  const getActivityLog = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/user/activity-log`, {
        withCredentials: true,
        params: {
          limit,
          page,
          searchText,
        },
      });
      setTotal(response.data.count);
      setAdmins(response.data.results);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = appConfig.name + " - Activity Log";
  }, []);

  useEffect(() => {
    getActivityLog();
  }, [searchText, limit, page]);

  const columns = [
    {
      title: "No.",
      key: "no",
      render: (_, __, index) => index + 1 + limit * (page - 1),
      width: "60px",
    },
    {
      title: "Authorized By",
      dataIndex: "activityOwner",
      key: "activityOwner",
      render: (activityOwner) => {
        return `${activityOwner?.name}${activityOwner?.role === "user" ? ` (${activityOwner?.customerId})` : ""}`;
      },
    },
    {
      title: "User Type",
      dataIndex: "activityOwner",
      key: "activityOwner1",
      render: (activityOwner) => (
        <p className="text-capitalize mb-0">
          {activityOwner?.role === userRole.user
            ? "Customer"
            : activityOwner?.role === userRole.superAdmin
              ? "Super admin"
              : activityOwner?.role === userRole.businessAdmin
                ? "Business admin"
                : activityOwner?.role === userRole.admin
                  ? "Site admin"
                  : activityOwner?.role}
        </p>
      ),
      width: 150,
    },
    {
      title: "Activity Message",
      dataIndex: "activityMsg",
      key: "activityMsg",
    },
    {
      title: "Time Stamp",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => moment(createdAt).format("DD-MM-YYYY, h:mm:ss a"),
      center: true,
      // minWidth: 400,
      width: 200,
    },
  ];

  return (
    <div className="card p-3 m-md-3">
      <div>
        <label className="az-content-label">Settings</label>
        <span className="d-block py-2">Manage Activity Log</span>
      </div>
      <hr className="mt-0" />
      <div className="row">
        <div className="col-md-9"></div>
        <div className="col-md-3">
          <Form className="d-flex">
            <Form.Control
              value={searchText}
              onChange={(e) => {
                setPage(1);
                setSearchText(e.target.value);
              }}
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
          </Form>
        </div>
      </div>
      <Spin spinning={isLoading}>
        <DataTable
          dataSource={admins}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={{
            defaultPageSize: limit,
            current: page,
            total,
            showSizeChanger: true,
            onShowSizeChange: (_, pageSize) => {
              setLimit(pageSize);
            },
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
            pageSizeOptions: [10, 20, 50],
            responsive: true,
          }}
          onChange={(pagination) => {
            setPage(pagination.current);
          }}
        />
      </Spin>
    </div>
  );
};

export default ActivityLog;
